exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter{background:#000;border:1px dotted #242424;margin-top:2em;padding:.5em;width:100%}.filter .filter-form{display:table}.filter .filter-label{display:table-cell;font-weight:700;margin:0 1em 0 0;padding:.25em .75em .25em .25em;vertical-align:middle}.filter .filter-select{color:#e9e9e9;font-family:Lato,sans-serif}.filter .custom-select{border:1px dotted #242424;display:table-cell;vertical-align:middle;width:100%}.filter .custom-select select:focus{color:#e9e9e9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/postcss-loader!./app/src/Portfolio/components/stylesheets/Filter.scss
// module id = 453
// module chunks = 0